// import "./update_student.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Select from "react-select";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { studentInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const DurationOptions = [
//   { value: "3hr", label: "3hr" },
//   { value: "2hr", label: "2hr" },
//   { value: "1hr", label: "1hr" },
// ];

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];
// const cstatusOptions = [
//   { value: "VIII", label: "VIII" },
//   { value: "IX", label: "IX" },
//   { value: "X", label: "X" },
//   { value: "XI", label: "XI" },
// ];
// const PaperOptions = [
//   { value: "A+", label: "A+" },
//   { value: "A", label: "A" },
//   { value: "B", label: "B" },
//   { value: "C", label: "C" },
//   { value: "D", label: "D" },
// ];

// const StudentUpdate = ({ title }) => {
//   // Extracting studentId using regular expressions
//   const location = useLocation();
//   const studentId = location.pathname.match(/\/update-student\/(\d+)/)?.[1];

//   // Initializing state
//   const [file, setFile] = useState(null);
//   const [file1, setFile1] = useState(null);
//   const [file2, setFile2] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedCstatus, setSelectedCstatus] = useState(null);
//   const [selectedPtype, setSelectedPtype] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [coption, setCoption] = useState([]);
//   const [soption, setSoption] = useState([]);
//   const [uoption, setUoption] = useState([]);
//   const center_id = localStorage.getItem("center_id");
//   const [inputValues, setInputValues] = useState("");
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchStudent = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/student/${studentId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         setInputValues(data.data);
//         const cnames = data.data.class_names;
//         const cid = data.data.class_id;
//         // console.log("abbas1",abbas);
//         const namelist = [];
//         const name = cnames;
//         console.log(name);
//         const id = cid; // Access the "name" property
//         namelist.push({ value: id, label: name });
//         setSelectedClass(namelist);
//         const bnames = data.data.batch_names;
//         const bid = data.data.batch_id;
//         // console.log("abbas1",abbas);
//         const namelist1 = [];
//         const nameb = bnames;
//         console.log(name);
//         const idb = bid; // Access the "name" property
//         namelist1.push({ value: idb, label: nameb });
//         setSelectedSubject(namelist1);
//         const gnames = data.data.group_names;
//         const gid = data.data.group_id;
//         setSelectedUser({ value: gid, label: gnames });
//         const status = data.data.status;
//         const last_class = data.data.last_class;
//         const last_grade = data.data.last_grade;
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }

//         setSelectedCstatus({ value: last_class, label: last_class });

//         setSelectedPtype({ value: last_grade, label: last_grade });
//         setFile(data.data.image_url);
//         setFile1(data.data.bform_url);
//         setFile2(data.data.marksheet_url);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (studentId) {
//       fetchStudent();
//     }
//   }, [studentId]);
//   // console.log("quiz in a state:", data);

//   const handleClassSelectChange = (selectedOption) => {
//     setSelectedClass(selectedOption);
//     setInputValues({
//       ...inputValues,
//       class_id: selectedOption.value,
//     });
//   };

//   useEffect(() => {
//     class_name();
//   }, []); // Empty dependency array means it runs once when the component mounts
//   const class_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         if (selectedClass == id) {
//           setSelectedClass({ value: id, label: name });
//         }
//         namelist.push({ value: id, label: name });
//       }
//       console.log(selectedClass);
//       console.log(namelist);
//       setCoption(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleSubjectSelectChange = (selectedOption) => {
//     setSelectedSubject(selectedOption);
//     setInputValues({
//       ...inputValues,
//       subject_id: selectedOption.value,
//     });
//   };

//   useEffect(() => {
//     batch_name();
//   }, []); // Empty dependency array means it runs once when the component mounts
//   const batch_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/batch_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         if (selectedSubject == id) {
//           setSelectedSubject({ value: id, label: name });
//         }
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setSoption(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleUserSelectChange = (selectedOption) => {
//     setSelectedUser(selectedOption);
//     setInputValues({
//       ...inputValues,
//       user_id: selectedOption.value,
//     });
//   };

//   useEffect(() => {
//     group_name();
//   }, []); // Empty dependency array means it runs once when the component mounts
//   const group_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/group_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         if (selectedUser == id) {
//           setSelectedUser({ value: id, label: name });
//         }
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setUoption(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleCstatusSelectChange = (selectedOption) => {
//     setSelectedCstatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       checking_status: selectedOption.value,
//     });
//   };

//   const handlePtypeSelectChange = (selectedOption) => {
//     setSelectedPtype(selectedOption);
//     setInputValues({
//       ...inputValues,
//       type: selectedOption.value,
//     });
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("image", file);
//     formData.append("name", inputValues.name);
//     formData.append("phone", inputValues.phone);
//     formData.append("father_name", inputValues.father_name);
//     formData.append("father_phone", inputValues.father_phone);
//     formData.append("father_cnic", inputValues.father_cnic);
//     formData.append("email", inputValues.email);
//     formData.append("address", inputValues.address);
//     formData.append("bform", file1);
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("batch_id", inputValues.batch_id);
//     formData.append("class_id", inputValues.class_id);
//     formData.append("group_id", inputValues.group_id);
//     formData.append("description", inputValues.description);
//     formData.append("ref_name", inputValues.ref_name);
//     formData.append("bform_number", inputValues.bform_number);
//     formData.append("marksheet", file2);
//     formData.append("ref_phone_no", inputValues.ref_phone_no);
//     formData.append("last_class", inputValues.last_class);
//     formData.append("last_grade", inputValues.last_grade);
//     formData.append("percentage", inputValues.percentage);
//     formData.append("status", inputValues.status || 1);
//     // formData.append("logo", file); // Append the file to FormData

//     // Send formData to the server using an HTTP request to update
//     fetch(`${serverUrl}/upd_student/${studentId}`, {
//       method: "PUT",
//       body: formData, // Pass the object as the body
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((data) => {
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "Something went wrong.");
//           }

//           // setFilteredOptions(options); // Reset available roles

//           // Force the component to rerender with the empty state
//           setTimeout(() => {}, 500); // Adding timeout to allow state change
//         } else {
//           toast.success("Student updated successfully!");
//           setTimeout(() => {
//             navigate("/student");
//           }, 1000);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="above">
//                 {/* Student Picture */}
//                 <div className="filePreview">
//                   {file && file.type && file.type.startsWith("image/") ? (
//                     <img
//                       src={URL.createObjectURL(file)}
//                       alt="Student Preview"
//                       className="itemImg"
//                     />
//                   ) : (
//                     <img
//                       src={file || "/images/upload_file.png"}
//                       alt="Default Student"
//                       className="itemImg"
//                     />
//                   )}
//                   <p className="fileName">
//                     {file instanceof File
//                       ? file.name
//                       : typeof file === "string" && file
//                       ? file.split("/").pop()
//                       : ""}
//                   </p>
//                 </div>

//                 {/* Bform */}
//                 <div className="filePreview">
//                   {file1 &&
//                   typeof file1 === "string" &&
//                   file1.endsWith(".pdf") ? (
//                     <img
//                       src="/images/pdf_icon.png"
//                       alt="Bform PDF"
//                       className="itemImg"
//                     />
//                   ) : file1 && file1.type && file1.type.startsWith("image/") ? (
//                     <img
//                       src={URL.createObjectURL(file1)}
//                       alt="Bform Preview"
//                       className="itemImg"
//                     />
//                   ) : (
//                     <img
//                       src={file1 || "/images/upload_file.png"}
//                       alt="Default Bform"
//                       className="itemImg"
//                     />
//                   )}
//                   <p className="fileName">
//                     {file1 instanceof File
//                       ? file1.name
//                       : typeof file1 === "string" && file1
//                       ? file1.split("/").pop()
//                       : ""}
//                   </p>
//                 </div>

//                 {/* Marksheet */}
//                 <div className="filePreview">
//                   {file2 &&
//                   typeof file2 === "string" &&
//                   file2.endsWith(".pdf") ? (
//                     <img
//                       src="/images/pdf_icon.png"
//                       alt="Marksheet PDF"
//                       className="itemImg"
//                     />
//                   ) : file2 && file2.type && file2.type.startsWith("image/") ? (
//                     <img
//                       src={URL.createObjectURL(file2)}
//                       alt="Marksheet Preview"
//                       className="itemImg"
//                     />
//                   ) : (
//                     <img
//                       src={file2 || "/images/upload_file.png"}
//                       alt="Default Marksheet"
//                       className="itemImg"
//                     />
//                   )}
//                   <p className="fileName">
//                     {file2 instanceof File
//                       ? file2.name
//                       : typeof file2 === "string" && file2
//                       ? file2.split("/").pop()
//                       : ""}
//                   </p>{" "}
//                 </div>
//               </div>

//               <div className="below">
//                 <form onSubmit={handleUpdate}>
//                   <div className="formInput">
//                     <label htmlFor="file">
//                       Image: <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       accept="image/*"
//                       id="file"
//                       onChange={(e) => setFile(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   <div className="formInput">
//                     <label htmlFor="Bformfile">
//                       Bform: <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="Bformfile"
//                       accept="image/*,.pdf"
//                       onChange={(e) => setFile1(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   <div className="formInput">
//                     <label htmlFor="marksheetfile">
//                       MarkSheet:{" "}
//                       <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="marksheetfile"
//                       accept="image/*,.pdf"
//                       onChange={(e) => setFile2(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   {studentInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "group_id" ? (
//                         <Select
//                           options={uoption}
//                           name={input.fieldName}
//                           value={selectedUser}
//                           onChange={handleUserSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "batch_id" ? (
//                         <Select
//                           options={soption}
//                           name={input.fieldName}
//                           value={selectedSubject}
//                           onChange={handleSubjectSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "class_id" ? (
//                         <Select
//                           options={coption}
//                           name={input.fieldName}
//                           value={selectedClass}
//                           onChange={handleClassSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "last_class" ? (
//                         <Select
//                           options={cstatusOptions}
//                           name={input.fieldName}
//                           value={selectedCstatus}
//                           onChange={handleCstatusSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "last_grade" ? (
//                         <Select
//                           options={PaperOptions}
//                           name={input.fieldName}
//                           value={selectedPtype}
//                           onChange={handlePtypeSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                           // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/categories`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/student`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}{" "}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default StudentUpdate;

import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { studentInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const classStatusOptions = [
  { value: "VIII", label: "VIII" },
  { value: "IX", label: "IX" },
  { value: "X", label: "X" },
  { value: "XI", label: "XI" },
];

const gradeOptions = [
  { value: "A+", label: "A+" },
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
];

const StudentUpdate = ({ title }) => {
  const location = useLocation();
  const studentId = location.pathname.match(/\/update-student\/(\d+)/)?.[1];
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [coptions, setCoptions] = useState([]);
  const [soptions, setSoptions] = useState([]);
  const [uoptions, setUoptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedClassStatus, setSelectedClassStatus] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const centerId = localStorage.getItem("center_id");
  const [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please login first to access this page");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const response = await fetch(`${serverUrl}/student/${studentId}`);
        if (!response.ok) throw new Error("Failed to fetch student data");
        const data = await response.json();

        setInputValues(data.data);
        setFile(data.data.image_url);
        setFile1(data.data.bform_url);
        setFile2(data.data.marksheet_url);

        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );

        setSelectedClassStatus({
          value: data.data.last_class,
          label: data.data.last_class,
        });

        setSelectedGrade({
          value: data.data.last_grade,
          label: data.data.last_grade,
        });

        setSelectedClass({
          value: data.data.class_id,
          label: data.data.class_names,
        });

        setSelectedBatch({
          value: data.data.batch_id,
          label: data.data.batch_names,
        });

        setSelectedGroup({
          value: data.data.group_id,
          label: data.data.group_names,
        });
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch student data");
      }
    };

    if (studentId) fetchStudent();
  }, [studentId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch classes
        const classesRes = await fetch(`${serverUrl}/class_ids/${centerId}`);
        const classesData = await classesRes.json();
        setCoptions(
          classesData.data.map((c) => ({ value: c.id, label: c.name }))
        );

        // Fetch batches
        const batchesRes = await fetch(`${serverUrl}/batch_ids/${centerId}`);
        const batchesData = await batchesRes.json();
        setSoptions(
          batchesData.data.map((b) => ({ value: b.id, label: b.name }))
        );

        // Fetch groups
        const groupsRes = await fetch(`${serverUrl}/group_ids/${centerId}`);
        const groupsData = await groupsRes.json();
        setUoptions(
          groupsData.data.map((g) => ({ value: g.id, label: g.name }))
        );
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load options");
      }
    };

    fetchData();
  }, [centerId]);

  const handleSelectChange = (field, selectedOption) => {
    const setters = {
      class_id: setSelectedClass,
      batch_id: setSelectedBatch,
      group_id: setSelectedGroup,
      status: setSelectedStatus,
      last_class: setSelectedClassStatus,
      last_grade: setSelectedGrade,
    };

    setters[field](selectedOption);
    setInputValues({
      ...inputValues,
      [field]: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (file instanceof File) formData.append("image", file);
    if (file1 instanceof File) formData.append("bform", file1);
    if (file2 instanceof File) formData.append("marksheet", file2);

    Object.entries(inputValues).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    try {
      const response = await fetch(`${serverUrl}/upd_student/${studentId}`, {
        method: "PUT",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => toast.error(`${field}: ${errMsg}`));
          });
        } else {
          toast.error(data.message || "Update failed");
        }
      } else {
        toast.success("Student updated successfully!");
        setTimeout(() => navigate("/student"), 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  const renderFilePreview = (file, defaultImage) => {
    if (file instanceof File) {
      if (file.type.startsWith("image/")) {
        return (
          <img
            src={URL.createObjectURL(file)}
            alt="Preview"
            className="filePreviewImg"
          />
        );
      }
      return (
        <img src="/images/pdf_icon.png" alt="PDF" className="filePreviewImg" />
      );
    } else if (typeof file === "string") {
      if (file.endsWith(".pdf")) {
        return (
          <img
            src="/images/pdf_icon.png"
            alt="PDF"
            className="filePreviewImg"
          />
        );
      }
      return (
        <img
          src={file || defaultImage}
          alt="Preview"
          className="filePreviewImg"
        />
      );
    }
    return <img src={defaultImage} alt="Default" className="filePreviewImg" />;
  };

  const getFileName = (file) => {
    if (file instanceof File) return file.name;
    if (typeof file === "string") return file.split("/").pop() || "";
    return "";
  };

  const renderSelectField = (field, options, value) => (
    <Select
      options={options}
      value={value}
      onChange={(option) => handleSelectChange(field, option)}
      required
      className="selectInput"
      styles={{
        control: (base) => ({
          ...base,
          minHeight: "46px",
          borderColor: "#e2e8f0",
          "&:hover": { borderColor: "#cbd5e0" },
        }),
        valueContainer: (base) => ({
          ...base,
          padding: "2px 8px",
        }),
        input: (base) => ({
          ...base,
          margin: "0",
          padding: "0",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: "44px",
        }),
      }}
    />
  );

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>

                  <div className="filePreviewGrid">
                    {["file", "bform", "marksheet"].map((type, index) => (
                      <div className="filePreviewItem" key={type}>
                        <label className="filePreviewLabel">
                          {type === "file"
                            ? "Student Image"
                            : type === "bform"
                            ? "Bform"
                            : "Marksheet"}
                        </label>
                        <div className="filePreviewBox">
                          {renderFilePreview(
                            index === 0 ? file : index === 1 ? file1 : file2,
                            "/images/upload_file.png"
                          )}
                          <p className="fileName">
                            {getFileName(
                              index === 0 ? file : index === 1 ? file1 : file2
                            )}
                          </p>
                          <label htmlFor={type} className="fileUploadBtn">
                            <DriveFolderUploadOutlinedIcon className="icon" />
                            <span>
                              Upload {type === "file" ? "Image" : type}
                            </span>
                          </label>
                          <input
                            type="file"
                            id={type}
                            accept={
                              type === "file" ? "image/*" : "image/*,.pdf"
                            }
                            onChange={(e) =>
                              index === 0
                                ? setFile(e.target.files[0])
                                : index === 1
                                ? setFile1(e.target.files[0])
                                : setFile2(e.target.files[0])
                            }
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {studentInputs
                        .filter((input) => input.fieldName !== "amount")
                        .map((input) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            key={input.id}
                            className="formGridItem"
                          >
                            <div className="formInput">
                              <label>{input.label}</label>
                              {input.fieldName === "class_id" ? (
                                renderSelectField(
                                  "class_id",
                                  coptions,
                                  selectedClass
                                )
                              ) : input.fieldName === "batch_id" ? (
                                renderSelectField(
                                  "batch_id",
                                  soptions,
                                  selectedBatch
                                )
                              ) : input.fieldName === "group_id" ? (
                                renderSelectField(
                                  "group_id",
                                  uoptions,
                                  selectedGroup
                                )
                              ) : input.fieldName === "status" ? (
                                renderSelectField(
                                  "status",
                                  statusOptions,
                                  selectedStatus
                                )
                              ) : input.fieldName === "last_class" ? (
                                renderSelectField(
                                  "last_class",
                                  classStatusOptions,
                                  selectedClassStatus
                                )
                              ) : input.fieldName === "last_grade" ? (
                                renderSelectField(
                                  "last_grade",
                                  gradeOptions,
                                  selectedGrade
                                )
                              ) : (
                                <input
                                  type={input.type}
                                  placeholder={input.placeholder}
                                  name={input.fieldName}
                                  value={inputValues[input.fieldName] || ""}
                                  onChange={handleInputChange}
                                  required={input.required}
                                />
                              )}
                            </div>
                          </Grid>
                        ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/student")}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                      >
                        Update Student
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default StudentUpdate;
